<template>
  <div class="blocks block"
    :class="[
      lift ? '_lift' : '',
      noBorder ? '_no-border' : ''
    ]"
  >
    <slot name="header" class="-header" v-if="hasHeaderSlot"/>

    <slot
      v-if="hasDefaultSlot"
      :class="[
        fit ? '_no-padding' : ''
      ]"
    >
    </slot>

    <div v-else>
      <span v-if="label && label !== ''" class="-label">{{ label }}</span>
      {{ data }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'label': {
      type: String,
      default: null
    },
    'data': {
      type: String || Number,
      default: null
    },
    'lift': {
      type: Boolean,
      default: false
    },
    'no-border': {
      type: Boolean,
      default: false
    },
    'fit': {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    hasHeaderSlot () {
      return !!this.$slots.header
    }
  }
}
</script>

<style lang="scss" scoped>
$block-padding: 8px 8px 8px 12px;
$block-border-radius: 4px;

.blocks {
  display: flex !important;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  border-radius: $block-border-radius;
  border: 1px solid transparent;
  overflow: hidden;
  -webkit-box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
  box-shadow: 0 0 5px 0 rgba(0,0,0,.1);
  -webkit-transition: all .3s ease;
  transition: all .3s ease;

  & .-header, & .-body {
    width: 100%;

    & > div {
      padding: $block-padding;
    }

    & > div._no-padding {
      padding: 0;
    }
  }

  &:hover {
    border-color: #eeeeee;
  }

  &._lift {
    height: auto;
    background: #fff;
    // border-radius: 8px;
    margin-bottom: 20px;
    border: 0px solid transparent;

    &:hover {
      -webkit-box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
      box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
      -webkit-transform: translateY(-1px);
      transform: translateY(-1px);
      border-color: transparent;
    }
  }

  &._no-border {
    box-shadow: none;
    border: none;
  }
}
</style>
